import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, createElementVNode as _createElementVNode, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "select-list" }
const _hoisted_2 = ["value"]
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = {
  key: 0,
  class: "own-list"
}
const _hoisted_5 = ["src", "alt", "onClick"]
const _hoisted_6 = { class: "tooltip" }
const _hoisted_7 = { class: "refine" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("ul", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weaponTypeList, (item) => {
        return (_openBlock(), _createElementBlock("li", { key: item }, [
          _createElementVNode("label", null, [
            _withDirectives(_createElementVNode("input", {
              class: "hidden",
              type: "radio",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedWeaponType) = $event)),
              value: item,
              name: "weapon-own-list-type"
            }, null, 8, _hoisted_2), [
              [_vModelRadio, _ctx.selectedWeaponType]
            ]),
            _createElementVNode("img", {
              class: "filter",
              src: _ctx.weaponSrc(item),
              alt: item
            }, null, 8, _hoisted_3)
          ])
        ]))
      }), 128))
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weaponTypeList, (weaponType) => {
      return (_openBlock(), _createElementBlock("div", { key: weaponType }, [
        (weaponType == _ctx.selectedWeaponType)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weaponList(weaponType), (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.key
                }, [
                  _createElementVNode("img", {
                    class: _normalizeClass('weapon' + _ctx.bgImageClass(item) + _ctx.notOwnedClass(item)),
                    src: item.icon_url,
                    alt: item.key,
                    onClick: ($event: any) => (_ctx.onClick(item))
                  }, null, 10, _hoisted_5),
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.displayName(item.key)), 1),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.refineObj[item.key]), 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
    }), 128)),
    _createElementVNode("label", null, [
      _withDirectives(_createElementVNode("input", {
        type: "checkbox",
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.savable) = $event)),
        disabled: !_ctx.changed
      }, null, 8, _hoisted_8), [
        [_vModelCheckbox, _ctx.savable]
      ]),
      _createElementVNode("span", null, _toDisplayString(_ctx.displayName("武器所持状況を保存する")), 1)
    ]),
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.save && _ctx.save(...args))),
      disabled: !_ctx.savable
    }, _toDisplayString(_ctx.displayName("実行")), 9, _hoisted_9)
  ], 64))
}